import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import { darken } from 'polished';
import _Blockquote from 'reakit/Blockquote';

var Blockquote = styled(_Blockquote).withConfig({
  displayName: "styled__Blockquote",
  componentId: "sc-1neijzl-0"
})(["border-left:4px solid ", ";padding:", "rem;&:not(:last-child){margin-bottom:", "rem;}&{", ";}"], darken(0.2, 'white'), space(4), space(4), theme('fannypack.Blockquote.base'));

export default Blockquote;
